import { combineReducers } from 'redux'
import courseCreationDrawer from './reducers/courseCreationDrawer'
import courseCreationCertificate from './reducers/certificate'

export default combineReducers({
  courseCreationDrawer,
  courseCreationCertificate,
})
